import { combineReducers } from "@reduxjs/toolkit";

import cart from "@/redux/reducers/cart";
import config from "@/redux/reducers/config";
import hydration, {
  HYDRATE,
  type HydrateAction,
} from "@/redux/reducers/hydration";
import cartDispensary from "@/redux/slices/cartDispensary";
import complianceRules from "@/redux/slices/complianceRules";
import dispensary from "@/redux/slices/dispensary";
import header from "@/redux/slices/header";
import location from "@/redux/slices/location";
import order from "@/redux/slices/order";
import search from "@/redux/slices/search";
import toasts from "@/redux/slices/toasts";
import user from "@/redux/slices/user";
import userAgent from "@/redux/slices/userAgent";
import weedfetti from "@/redux/slices/weedfetti";

const combinedReducer = combineReducers({
  cart,
  cartDispensary,
  complianceRules,
  config,
  dispensary,
  header,
  hydration,
  location,
  order,
  search,
  toasts,
  user,
  userAgent,
  weedfetti,
});

const rootReducer: typeof combinedReducer = (state, action) => {
  /**
   * This will apply all state from the initial SSR hydration to the client's state.
   * This should only happen once when the frontend parses the initial state from SSR.
   * Subsequent calls to HYDRATE, like when you do a client-side page navigation, should
   * fall through to: combinedReducer(state, action) allowing you to handle the
   * hydration in a reducer.
   *
   * Note that if you dispatch any redux events in `getServerSideProps` or `getStaticProps`,
   * you MUST handle the hydration action in the corresponding reducers if you want data
   * from those events will not be persisted to the redux store during client-side navigation.
   */
  if (action.type === HYDRATE && !state?.hydration?.hasHydrated) {
    return combinedReducer(
      { ...state, ...(action as HydrateAction).payload },
      action,
    );
  } else {
    return combinedReducer(state, action);
  }
};

export default rootReducer;
